import React from 'react';
import { PlayCircle } from 'lucide-react';
import MediaPreview from './SharedMediaPreview';

interface VideoPreviewerProps {
    fileName: string;
}

const VideoPreviewer: React.FC<VideoPreviewerProps> = ({ fileName }) => {
    // If no fileName, show placeholder immediately
    if (!fileName) {
        return (
            <div className="fallback-content w-full h-full flex flex-col items-center justify-center gap-1 text-white bg-black">
                <PlayCircle className="h-6 w-6" />
                <span className="text-xs">Video Placeholder</span>
            </div>
        );
    }

    return (
        <div className="w-full h-full bg-black" style={{ overflow: 'hidden' }}>
            <MediaPreview
                fileName={fileName}
                type="video"
                className="w-full h-full"
                style={{ objectFit: 'contain', width: '100%', height: '100%' }}
            />
        </div>
    );
};

export default VideoPreviewer;
